import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { IHotelListItem } from '../../contexts/HotelsListContext';
import { useHistory } from 'react-router-dom';
import { formatDateTime } from '../../../../utils/formatDates';
import useTimeZone from '../../../../customHooks/useTimeZone';
import useLanguage from '../../../../customHooks/useLanguage';
import Tag from '../../../../muiComponents/Tag';
import {
    STATUS_TAG_COLORS,
    STATUS_KEYS,
} from '../../utils/zitoneoServicesUtils';
import Menu from '../../../ownerPortal/components/Menu';
import { ZitoneoViewMode } from '../../types/zitoneoServicesTypes';
import { zitoneoRoutes } from '../../utils/zitoneoRoutes';

interface HotelRowProps {
    hotel: IHotelListItem;
}

const HotelRow = (props: HotelRowProps) => {
    const { hotel } = props;
    const history = useHistory();
    const language = useLanguage();
    const timeZone = useTimeZone();
    const goToView = (view: ZitoneoViewMode) => {
        const route =
            view === ZitoneoViewMode.PREVIEW
                ? zitoneoRoutes.HOTEL_PREVIEW(hotel.Id)
                : view === ZitoneoViewMode.SETTINGS
                ? zitoneoRoutes.HOTEL_SETTINGS(hotel.Id)
                : zitoneoRoutes.HOTEL_EDITOR_HOTEL(hotel.Id);
        history.push(route);
    };

    const menuItems = [
        {
            text: 'edit',
            icon: 'Edit',
            onClick: () => goToView(ZitoneoViewMode.EDITOR),
        },
        {
            text: 'preview',
            icon: 'Language',
            onClick: () => goToView(ZitoneoViewMode.PREVIEW),
        },
        {
            text: 'settings',
            icon: 'SettingsOutlined',
            onClick: () => goToView(ZitoneoViewMode.SETTINGS),
        },
        { type: 'divider' },
        {
            text: 'publication_status',
            icon: 'CloudUploadOutlined',
            onClick: () => goToView(ZitoneoViewMode.SETTINGS),
        },
    ];

    return (
        <TableRow
            hover
            style={{ cursor: 'pointer' }}
            onClick={() => {
                history.push(zitoneoRoutes.HOTEL_PRESENTATION(hotel.Id));
            }}
        >
            <TableCell className='row__hotel-name'>{hotel.Name}</TableCell>
            <TableCell>
                {hotel.ZitoneoPublishStatusKey !== STATUS_KEYS.NOT_STARTED ? (
                    <Tag
                        variant={
                            hotel.ZitoneoPublishStatusKey === STATUS_KEYS.DRAFT
                                ? 'outlined'
                                : 'contrast'
                        }
                        text={hotel.ZitoneoPublishStatus}
                        color={
                            STATUS_TAG_COLORS[
                                hotel.ZitoneoPublishStatusKey as keyof typeof STATUS_TAG_COLORS
                            ]
                        }
                        uppercase
                    />
                ) : (
                    ''
                )}
            </TableCell>
            <TableCell>
                {hotel.IdZitoneoChange
                    ? formatDateTime(hotel.LastChange, language, timeZone)
                    : ''}
            </TableCell>
            <TableCell>
                <Menu menuItems={menuItems} />
            </TableCell>
        </TableRow>
    );
};

export default HotelRow;
